import { useRouter } from 'next/router'
import React from 'react'

export const withPreventBrowserNavigation = (Component) => (props) => {
  const router = useRouter()

  if (typeof window !== 'undefined') {
    router.beforePopState(() => {
      let route = router.pathname

      if (typeof router.query !== 'undefined' && Object.keys(router.query).length > 0) {
        route = router.asPath
      }

      router.push(route)

      return false
    })
  }

  return <Component {...props} />
}
